export default __webpack_public_path__ + "static/media/fNeutral19.b1f06bfc.png";